import Vue from 'vue';
import { mapGetters } from 'vuex';
export default Vue.extend({
    metaInfo() {
        return {
            title: this.currentSite ? `${this.currentSite.site_name} Settings - Kapiche` : null
        };
    },
    computed: {
        ...mapGetters(['isAdmin', 'featureFlags', 'currentSite', 'currentUser', 'subscription']),
        showPasswordReset() {
            return !this.currentUser?.is_social;
        }
    },
});
